<template>
  <div class="container">
     <div class="bottomBox">
			<a-input style="width: 200px; margin-right: 5px;" v-model=" searchData.recordCode" allowClear placeholder="记录编号"
				@keyup.enter.native="search" />
            <a-input class="a_select_self margin_self" v-model="searchData.customerName" allowClear placeholder="客户名称"
				@keyup.enter.native="search" />
            <a-input class="a_select_self margin_self" v-model="searchData.salesman" allowClear placeholder="报价人"
				@keyup.enter.native="search" /> 
            <a-select class="a_select_self margin_self" allowClear placeholder="请选择报价公司" v-model="searchData.companyId" @change="companyChange" style="width: 160px;" 
            show-search :filter-option="filterOption">
                  <a-select-option :value="item.value" v-for="(item, index) in companyList" :key="index">
                    {{ item.title }}
                  </a-select-option>
            </a-select>
       
             
            <a-button type="primary" @click="search"> 查询 </a-button>
			<a-button type="primary" @click="queryall"> 重置 </a-button>
        </div>
        <div class="contentBottom" id="content_main_center_scroll">
            <a-table :data-source="detailList" bordered :loading="loading" :pagination="false"
				:scroll="{ y: scroll_y, scrollToFirstRowOnChange: true }">
				<a-table-column key="index" title="序号" ellipsis="true" data-index="index" width="60px">
                  <template scope="text, record, index">{{ (pagination.current - 1) * pagination.pageSize + index + 1 }}</template>
				</a-table-column>
				<a-table-column key="recordCode" title="记录编号" ellipsis="true" data-index="recordCode" width="130px"/>
				<a-table-column key="companyName" title="客户名称"  data-index="companyName" width="160px"/>
                <a-table-column title="报价项目" width="200px">
                    <template scope="text,record">
                    	<div  v-for="(item, index ) in record.quoteProjectList" :key="index">
                           {{ record.quoteProjectList[index] }}
						</div>
                   </template>
                </a-table-column> 
				<a-table-column key="totalPrice" title="总计(不含税)" ellipsis="true" data-index="totalPrice" width="80px"/>
				<a-table-column key="excludeTaxesPrice" title="优惠价" ellipsis="true" data-index="excludeTaxesPrice" width="80px"/>
				<a-table-column key="discount" title="折扣" ellipsis="true" data-index="discount" width="70px"/>
                <a-table-column key="salesInfo" title="报价人" ellipsis="true" data-index="salesInfo"  width="160px"/>
                <!-- <a-table-column key="quoteProject" title="报价公司" ellipsis="true" data-index="quoteProject" />
                <a-table-column key="salesInfo" title="报价部门" ellipsis="true" data-index="salesInfo" /> -->
				<a-table-column title="操作" width="100px">
					<template scope="text,record">
						<a @click="details(record)">详情</a>
                    </template>
                </a-table-column>
            </a-table>
                                  <div class="pageBottom">
                               <a-pagination
            v-model="pagination.current"
            show-size-changer
            :page-size.sync="pagination.pageSize"
            :total="pagination.totalCount"
			      @showSizeChange="onShowSizeChange"
            :pageSizeOptions="['10', '20', '30','40', '50']"
            @change="onShowSizeChange"
          />
            </div> 
           <!-- <Pagination 
              v-model="pagination.current"
              :total="pagination.totalCount"
              show-size-changer
              :page-size="pagination.pageSize"
              @onShowSizeChange="onShowSizeChange"
              ></Pagination> -->
           
        </div>
        <RrcordsPrice :recordsVisible="recordsVisible" @changeRecords="changeRecords" :recordsForm="recordsForm" :detailList1="detailList1" :recordsData="recordsData"></RrcordsPrice>
        

  </div>
</template>

<script>
import RrcordsPrice from './recordsPrice/index.vue'
import Pagination from '@/components/pagination/index.vue'
import { Pricelist, recordsDetails,  customerInfo_details, detailsList, exportPrice} from '@/api/Industry'
import { tree_all } from '@/api/purchase'
export default {
     components: {
        Pagination,
        RrcordsPrice
     },
    data() {
        return {
            recordsData: {},
            choose: false,
            detailList1: [],
            customerList: [],
            recordsForm: [],
            recordsVisible: false,
            searchData: {
                recordCode: '',
                salesInfo: '',
                customerName: '',
                companyName: '',
                companyId: undefined
            },
            scroll_y: 150,
            detailList: [],
            // pagination:{ //分页数据
            //      current : 1,
            //      pageSize: 10,
            //      totalCount: 500
            // },
             pagination:{ //分页数据
			     pageSizeOptions: ['10', '20', '30', '40', '50'],
                 current : 1,
                 pageSize: 10,
                 totalCount: 0
            },
            companyList: []


        }

    },
    created() {
			this.serch_get_lis()
			this.$nextTick(() => {
				var max_h = $('#content_main_center_scroll').height()
                console.log(max_h, 'max_hmax_hmax_hmax_hmax_hmax_h')
				// setTimeout(() => {
					this.scroll_y = max_h - $('.ant-table-header').height() + 400
                     console.log(this.scroll_y, 'scroll_y=====================')
				// }, 1000)
			})
            tree_all().then(res => {
                if(res.code == 200) {
                    this.companyList = res.data[0]
                   console.log(res,'res============================')
                } else {
                    this.$message.error(res.msg)
                }
            })
		},
    methods: {
        companyChange(e){
            this.companyList.forEach(item => {
                if(item.value == e) {
                    this.searchData.companyName = item.title

                }
            })

        },
      
        derive() {
            // 导出文件
            // exportPrice()
            this.choose = true


        },
        changeRecords(data) {
            this.recordsVisible = data
        },
        //查询下拉列表
         filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
        //查询事件
         search() {
             console.log('1111111111111111111111111111111')
            // this.loading = true
       this.pagination.current = 1
       this.pagination.pageSize = 10
	   this.serch_get_lis()

        },
        //分页
          onShowSizeChange(current, pageSize) {
        console.log(current, pageSize);
        this.pagination.current = current
        this.pagination.pageSize = pageSize;
        //改变完 重新渲染数据
        this.serch_get_lis()
      },
        //查询
        serch_get_lis(){
            Pricelist({
                //  keeper: this.userName,
           pageNum: this.pagination.current,
		   pageSize: this.pagination.pageSize,
           recordCode: this.searchData.recordCode,
           customerName: this.searchData.customerName,
           salesman: this.searchData.salesman,
        //    companyId: this.searchData.companyId,
           companyName: this.searchData.companyName,

        //    assetSn: this.storage.assetSn,
        //    assetType: this.storage.assetTypeName,
        //    name: this.storage.name
            }).then(res => {
                if(res.code == 200) {
                  
                     res.data.forEach(item1=> {
                         var a =item1.quoteProject.split(",")
                           Object.assign(item1, {
                           quoteProjectList:  []
                             })
                        a.forEach(item => {
                        item1.quoteProjectList.push(item)
                        })

                     })
                     console.log(res.data, 'res.data=============================')
                    this.detailList = res.data
                   this.pagination.totalCount = res.total
                }

                console.log(res, 'res=====================================')
            })

        },
        //重置
        queryall() {
            this.searchData = {}
             this.serch_get_lis()
            console.log('11111111111111111111111111')

        },
        //详情
        details(record) {
            this.recordsVisible = true
            this.recordsData = record
             console.log(record,'record11111111111111111111111111')
             recordsDetails(record.id).then(res => {
                 if(res.code == 200) {
                     this.recordsForm = res.data
                     console.log(res.data, 'res.data=================================')
                       customerInfo_details(this.recordsForm.customerId).then(res1 => {
                           if(res1.code == 200) {
                               Object.assign(this.recordsForm, {
                                   address: res1.data.address ,
                                   customerName: res1.data.customerName ,
                                   customerTelephone: res1.data.telephone ,
                                   fixedTelephone: res1.data.fixedTelephone ,
                                   customerEmail: res1.data.email ,

                               })
                               detailsList({
                                   sheetId: record.id,
                               }).then(res2 => {
                                if(res.code == 200) {
                                   this.detailList1 = res2.data
                                   console.log(this.detailList1)
                                }

                                   

                               })
                           }
             })
                 } else {
                     this.$message.error(res.msg)
                 }
             })
             //获取客户信息
           


        }
    }

}
</script>

<style  scoped>
.container {
    padding: 10px;
    padding-bottom: 40px;
    overflow: scroll;
    height: 100vh;
}
.bottomBox {
    width: 100%;
    display: flex;
    align-content: space-between;

    margin: 20px 10px;
    
    /* position: absolute;
    margin-right: 10px;
    margin-bottom: 10px; */


}
.pageBottom {
    margin: 10px;
    display: flex;
    flex-direction: row-reverse;
}

</style>